/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AppInfo = {
  __typename?: 'AppInfo';
  version?: Maybe<Scalars['String']>;
};

export type Article = {
  __typename?: 'Article';
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Audio = {
  __typename?: 'Audio';
  id: Scalars['Int'];
  recitationSubtype?: Maybe<Scalars['String']>;
  recitationType: Scalars['String'];
  reciterName: Scalars['String'];
};

export type Author = {
  __typename?: 'Author';
  dateOfDeath?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Book = {
  __typename?: 'Book';
  altTitle?: Maybe<Scalars['String']>;
  author?: Maybe<Author>;
  authorName?: Maybe<Scalars['String']>;
  blurb?: Maybe<Scalars['String']>;
  bookSections?: Maybe<Array<Maybe<BookSection>>>;
  chapters?: Maybe<Array<Maybe<Chapter>>>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  englishName?: Maybe<Scalars['String']>;
  gradings?: Maybe<Array<Maybe<Grading>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentBook?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  translator?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['Int']>;
  volumes?: Maybe<Array<Maybe<Scalars['Int']>>>;
  year?: Maybe<Scalars['Int']>;
};

export type BookNameAndChapterName = {
  __typename?: 'BookNameAndChapterName';
  bookName?: Maybe<Scalars['String']>;
  bookType?: Maybe<Scalars['String']>;
  chapterName?: Maybe<Scalars['String']>;
  sectionName?: Maybe<Scalars['String']>;
};

export type BookSection = {
  __typename?: 'BookSection';
  book?: Maybe<Book>;
  book_id?: Maybe<Scalars['Int']>;
  chapters?: Maybe<Array<Maybe<Chapter>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sectionNumber?: Maybe<Scalars['Int']>;
};

export type Chains = {
  __typename?: 'Chains';
  book?: Maybe<Book>;
  bookSection?: Maybe<Scalars['Int']>;
  chapter?: Maybe<Chapter>;
  data?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['Int']>;
};

export type Chapter = {
  __typename?: 'Chapter';
  book?: Maybe<Book>;
  bookName?: Maybe<Scalars['String']>;
  bookNumber?: Maybe<Scalars['Int']>;
  bookSection?: Maybe<Scalars['Int']>;
  hadiths?: Maybe<Array<Maybe<Hadith>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
};

export type Dua = {
  __typename?: 'Dua';
  blurb?: Maybe<Scalars['String']>;
  duaMetaId?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  verseGroups?: Maybe<Array<Maybe<VerseGroup>>>;
};

export type EditLog = {
  __typename?: 'EditLog';
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  book?: Maybe<Book>;
  bookSection?: Maybe<BookSection>;
  chapter?: Maybe<Chapter>;
  created_at?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  diff?: Maybe<Scalars['String']>;
  hadith?: Maybe<Hadith>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Grading = {
  __typename?: 'Grading';
  book?: Maybe<Book>;
  bookSection?: Maybe<Scalars['Int']>;
  book_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  grading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  reference?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Hadith = {
  __typename?: 'Hadith';
  book?: Maybe<Book>;
  bookSection?: Maybe<Scalars['Int']>;
  chapter?: Maybe<Chapter>;
  comments?: Maybe<Array<Maybe<HadithComment>>>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  embeddings?: Maybe<Array<Maybe<Scalars['Float']>>>;
  gradingWithReferences?: Maybe<Scalars['String']>;
  gradings?: Maybe<Array<Maybe<Grading>>>;
  id?: Maybe<Scalars['Int']>;
  jsonChains?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  nextHadith?: Maybe<Hadith>;
  number?: Maybe<Scalars['Int']>;
  previousHadith?: Maybe<Hadith>;
  startingIndex?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['String']>;
};

export type HadithComment = {
  __typename?: 'HadithComment';
  authorName?: Maybe<Scalars['String']>;
  bookId?: Maybe<Scalars['Int']>;
  bookSectionNumber?: Maybe<Scalars['Int']>;
  chapterNumber?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  hadithNumber?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBook?: Maybe<Book>;
  addEmbedding?: Maybe<Scalars['String']>;
  addHadith?: Maybe<Hadith>;
  addHadithStartingIndex?: Maybe<Scalars['String']>;
  addReport?: Maybe<Scalars['String']>;
  addReportWithHadithId?: Maybe<Scalars['String']>;
  addTest?: Maybe<Scalars['String']>;
  computeEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  solveReport?: Maybe<Scalars['String']>;
  updateHadith?: Maybe<Scalars['String']>;
};


export type MutationAddBookArgs = {
  author?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type MutationAddEmbeddingArgs = {
  embeddings?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  hadithId?: InputMaybe<Scalars['String']>;
};


export type MutationAddHadithArgs = {
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  hadithNumber?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
};


export type MutationAddHadithStartingIndexArgs = {
  hadithId?: InputMaybe<Scalars['String']>;
  startingIndex?: InputMaybe<Scalars['String']>;
};


export type MutationAddReportArgs = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
};


export type MutationAddReportWithHadithIdArgs = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  hadithId?: InputMaybe<Scalars['String']>;
};


export type MutationAddTestArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationComputeEmbeddingArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type MutationSolveReportArgs = {
  reportId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateHadithArgs = {
  content?: InputMaybe<Scalars['String']>;
  hadithId?: InputMaybe<Scalars['String']>;
  startingIndex?: InputMaybe<Scalars['String']>;
};

export type Narrator = {
  __typename?: 'Narrator';
  data?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type Post = {
  __typename?: 'Post';
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  allArticles?: Maybe<Array<Maybe<Article>>>;
  allBookIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  allBooks?: Maybe<Array<Maybe<Book>>>;
  allDuas?: Maybe<Array<Maybe<Dua>>>;
  app?: Maybe<AppInfo>;
  audios: Array<Maybe<Audio>>;
  author?: Maybe<Author>;
  book?: Maybe<Book>;
  bookByPath?: Maybe<Book>;
  bookSection?: Maybe<BookSection>;
  chains?: Maybe<Chains>;
  chapter?: Maybe<Chapter>;
  chapterByNumberAndSection?: Maybe<Chapter>;
  dua?: Maybe<Dua>;
  duaByPath?: Maybe<Dua>;
  editLog?: Maybe<EditLog>;
  edits?: Maybe<Array<Maybe<EditLog>>>;
  getChainsByNumberAndSection?: Maybe<Array<Maybe<Chains>>>;
  getChapterNameAndBookName?: Maybe<BookNameAndChapterName>;
  getHadithByNumberAndSection?: Maybe<Array<Maybe<Hadith>>>;
  grading?: Maybe<Grading>;
  hadith?: Maybe<Hadith>;
  hadithComment?: Maybe<HadithComment>;
  narrator?: Maybe<Narrator>;
  page: Array<Maybe<Verse>>;
  post?: Maybe<Post>;
  randomHadith?: Maybe<Hadith>;
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
  reportsForHadith?: Maybe<Array<Maybe<Report>>>;
  scholar?: Maybe<Scholar>;
  surah: Surah;
  surahs: Array<Surah>;
  tafsirs: Array<Maybe<Tafsir>>;
  translations: Array<Maybe<Translation>>;
  unsolvedReportsCount?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  verse: QuranVerse;
  word: Word;
};


export type QueryAuthorArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBookArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBookByPathArgs = {
  path?: InputMaybe<Scalars['String']>;
};


export type QueryBookSectionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryChainsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryChapterArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryChapterByNumberAndSectionArgs = {
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
};


export type QueryDuaArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDuaByPathArgs = {
  path?: InputMaybe<Scalars['String']>;
};


export type QueryEditLogArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryEditsArgs = {
  hadithId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetChainsByNumberAndSectionArgs = {
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
  hadithNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetChapterNameAndBookNameArgs = {
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetHadithByNumberAndSectionArgs = {
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
  hadithNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGradingArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryHadithArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryHadithCommentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryNarratorArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPageArgs = {
  p?: InputMaybe<Scalars['Int']>;
  s?: InputMaybe<Scalars['Int']>;
};


export type QueryPostArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryReportArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryReportsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};


export type QueryReportsForHadithArgs = {
  hadithId?: InputMaybe<Scalars['Int']>;
};


export type QueryScholarArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QuerySurahArgs = {
  surahNumber: Scalars['Int'];
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVerseArgs = {
  surahNumber: Scalars['Int'];
  verseNumber: Scalars['Int'];
};


export type QueryWordArgs = {
  surahNumber: Scalars['Int'];
  verseNumber: Scalars['Int'];
  wordNumber: Scalars['Int'];
};

export type QuranVerse = {
  __typename?: 'QuranVerse';
  arabic: Scalars['String'];
  azmammadaliyev: Scalars['String'];
  azmehdiyev: Scalars['String'];
  enahmedali: Scalars['String'];
  enchinoy: Scalars['String'];
  enqarai: Scalars['String'];
  ensarwar: Scalars['String'];
  enyusufali: Scalars['String'];
  faansarian: Scalars['String'];
  faayati: Scalars['String'];
  fabahrampour: Scalars['String'];
  fafoolavand: Scalars['String'];
  fagharaati: Scalars['String'];
  faghomshei: Scalars['String'];
  fakhorramdel: Scalars['String'];
  fakhorramshahi: Scalars['String'];
  famakarem: Scalars['String'];
  famoezzi: Scalars['String'];
  famojtabavi: Scalars['String'];
  fasadeqi: Scalars['String'];
  frfakhri: Scalars['String'];
  hijawadi: Scalars['String'];
  id: Scalars['String'];
  indopak: Scalars['String'];
  page: Scalars['Int'];
  ruzeynalov: Scalars['String'];
  surahNumber: Scalars['Int'];
  tjayati: Scalars['String'];
  transliterationEnd?: Maybe<Scalars['String']>;
  transliterationStart?: Maybe<Scalars['String']>;
  trgolpinarli: Scalars['String'];
  urahmedali: Scalars['String'];
  urjawadi: Scalars['String'];
  urnajafi: Scalars['String'];
  ursafdar: Scalars['String'];
  uthmani: Scalars['String'];
  verseNumber: Scalars['Int'];
  words: Array<Maybe<Word>>;
};

export type Report = {
  __typename?: 'Report';
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  referer?: Maybe<Scalars['String']>;
  solved?: Maybe<Scalars['Boolean']>;
  solved_by?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Scholar = {
  __typename?: 'Scholar';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Surah = {
  __typename?: 'Surah';
  id: Scalars['Int'];
  index: Scalars['Int'];
  nameArabic: Scalars['String'];
  nameEnglish: Scalars['String'];
  pageEnd: Scalars['Int'];
  pageStart: Scalars['Int'];
  place: Scalars['String'];
  surahNumber: Scalars['Int'];
  transliteration: Scalars['String'];
  verseCount: Scalars['Int'];
  verses: Array<QuranVerse>;
};

export type Tafsir = {
  __typename?: 'Tafsir';
  authorName: Scalars['String'];
  id: Scalars['Int'];
  languageKey: Scalars['String'];
  languageName: Scalars['String'];
  languageNameEnglish: Scalars['String'];
};

export type Tag = {
  __typename?: 'Tag';
  created_at?: Maybe<Scalars['String']>;
  hadiths?: Maybe<Array<Maybe<Hadith>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Translation = {
  __typename?: 'Translation';
  authorName: Scalars['String'];
  id: Scalars['Int'];
  languageKey: Scalars['String'];
  languageName: Scalars['String'];
  languageNameEnglish: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Verse = {
  __typename?: 'Verse';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type VerseGroup = {
  __typename?: 'VerseGroup';
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  verses?: Maybe<Array<Maybe<Verse>>>;
};

export type Word = {
  __typename?: 'Word';
  arabic: Scalars['String'];
  bangla: Scalars['String'];
  english: Scalars['String'];
  german: Scalars['String'];
  hindi: Scalars['String'];
  indonesian: Scalars['String'];
  indopak: Scalars['String'];
  ingush: Scalars['String'];
  root: Scalars['String'];
  russian: Scalars['String'];
  surahNumber: Scalars['Int'];
  transliteration: Scalars['String'];
  turkish: Scalars['String'];
  urdu: Scalars['String'];
  uthmani: Scalars['String'];
  verseNumber: Scalars['Int'];
  wordNumber: Scalars['Int'];
};

export type GetHadithQueryVariables = Exact<{
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
  hadithNumber?: InputMaybe<Scalars['String']>;
}>;


export type GetHadithQuery = { __typename?: 'Query', getHadithByNumberAndSection?: Array<{ __typename?: 'Hadith', id?: number | null, content?: string | null, number?: number | null, language?: string | null, gradingWithReferences?: string | null, jsonChains?: string | null, startingIndex?: number | null, comments?: Array<{ __typename?: 'HadithComment', comments?: string | null, authorName?: string | null } | null> | null, book?: { __typename?: 'Book', id?: number | null, name?: string | null, authorName?: string | null, type?: string | null } | null, chapter?: { __typename?: 'Chapter', name?: string | null } | null } | null> | null };

export type GetReportQueryQueryVariables = Exact<{
  hadithId?: InputMaybe<Scalars['Int']>;
}>;


export type GetReportQueryQuery = { __typename?: 'Query', reportsForHadith?: Array<{ __typename?: 'Report', id?: number | null, solved?: boolean | null, email?: string | null, created_at?: string | null, description?: string | null, solved_by?: string | null } | null> | null };

export type GetNarratorQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetNarratorQuery = { __typename?: 'Query', narrator?: { __typename?: 'Narrator', data?: string | null } | null };

export type GetSolvedReportsQueryVariables = Exact<{
  solved: Scalars['Boolean'];
}>;


export type GetSolvedReportsQuery = { __typename?: 'Query', reports?: Array<{ __typename?: 'Report', id?: number | null, solved?: boolean | null, description?: string | null, identifier?: string | null, created_at?: string | null } | null> | null };

export type GetRandomHadithQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRandomHadithQuery = { __typename?: 'Query', randomHadith?: { __typename?: 'Hadith', id?: number | null, bookSection?: number | null, number?: number | null, chapter?: { __typename?: 'Chapter', number?: number | null } | null, book?: { __typename?: 'Book', id?: number | null } | null } | null };

export type ReportHadithMutationVariables = Exact<{
  description: Scalars['String'];
  identifier: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type ReportHadithMutation = { __typename?: 'Mutation', addReport?: string | null };

export type GetBookIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookIdsQuery = { __typename?: 'Query', allBookIds?: Array<string | null> | null };

export type GetBookQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBookQuery = { __typename?: 'Query', book?: { __typename?: 'Book', id?: number | null, name?: string | null, englishName?: string | null, volumes?: Array<number | null> | null, volume?: number | null, blurb?: string | null, translator?: string | null, authorName?: string | null, author?: { __typename?: 'Author', name?: string | null, link?: string | null, dateOfDeath?: string | null } | null, chapters?: Array<{ __typename?: 'Chapter', id?: number | null, number?: number | null, bookSection?: number | null, name?: string | null } | null> | null, bookSections?: Array<{ __typename?: 'BookSection', id?: number | null, name?: string | null, sectionNumber?: number | null, chapters?: Array<{ __typename?: 'Chapter', id?: number | null, name?: string | null, number?: number | null, bookSection?: number | null } | null> | null } | null> | null } | null };

export type GetBooksAllChaptersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBooksAllChaptersQuery = { __typename?: 'Query', allBooks?: Array<{ __typename?: 'Book', chapters?: Array<{ __typename?: 'Chapter', id?: number | null, name?: string | null, number?: number | null, bookNumber?: number | null, bookSection?: number | null } | null> | null } | null> | null };

export type GetHadithsQueryVariables = Exact<{
  bookId: Scalars['String'];
  bookSectionNumber: Scalars['String'];
  chapterNumber: Scalars['String'];
}>;


export type GetHadithsQuery = { __typename?: 'Query', getHadithByNumberAndSection?: Array<{ __typename?: 'Hadith', id?: number | null, content?: string | null, number?: number | null, language?: string | null, gradingWithReferences?: string | null, jsonChains?: string | null, startingIndex?: number | null, comments?: Array<{ __typename?: 'HadithComment', comments?: string | null, authorName?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', name?: string | null } | null> | null } | null> | null };

export type GetChapterDetailsQueryVariables = Exact<{
  bookId: Scalars['String'];
  bookSectionNumber: Scalars['String'];
  chapterNumber: Scalars['String'];
}>;


export type GetChapterDetailsQuery = { __typename?: 'Query', getChapterNameAndBookName?: { __typename?: 'BookNameAndChapterName', bookName?: string | null, bookType?: string | null, sectionName?: string | null, chapterName?: string | null } | null };

export type UpdateHadithMutationMutationVariables = Exact<{
  hadithId: Scalars['String'];
  content?: InputMaybe<Scalars['String']>;
  startingIndex?: InputMaybe<Scalars['String']>;
}>;


export type UpdateHadithMutationMutation = { __typename?: 'Mutation', updateHadith?: string | null };

export type GetDuaQueryVariables = Exact<{
  path?: InputMaybe<Scalars['String']>;
}>;


export type GetDuaQuery = { __typename?: 'Query', duaByPath?: { __typename?: 'Dua', id?: number | null, name?: string | null, languages?: Array<string | null> | null, blurb?: string | null, source?: string | null, verseGroups?: Array<{ __typename?: 'VerseGroup', name?: string | null, language?: string | null, verses?: Array<{ __typename?: 'Verse', index?: number | null, content?: string | null } | null> | null } | null> | null } | null };

export type GetAllDuasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDuasQuery = { __typename?: 'Query', allDuas?: Array<{ __typename?: 'Dua', id?: number | null, path?: string | null } | null> | null };

export type GetHadithForHadithPageQueryVariables = Exact<{
  bookId?: InputMaybe<Scalars['String']>;
  bookSectionNumber?: InputMaybe<Scalars['String']>;
  chapterNumber?: InputMaybe<Scalars['String']>;
  hadithNumber?: InputMaybe<Scalars['String']>;
}>;


export type GetHadithForHadithPageQuery = { __typename?: 'Query', getHadithByNumberAndSection?: Array<{ __typename?: 'Hadith', id?: number | null, content?: string | null, number?: number | null, language?: string | null, gradingWithReferences?: string | null, jsonChains?: string | null, startingIndex?: number | null, comments?: Array<{ __typename?: 'HadithComment', comments?: string | null, authorName?: string | null } | null> | null, book?: { __typename?: 'Book', id?: number | null, name?: string | null, authorName?: string | null, type?: string | null } | null, chapter?: { __typename?: 'Chapter', name?: string | null } | null, nextHadith?: { __typename?: 'Hadith', number?: number | null } | null, previousHadith?: { __typename?: 'Hadith', number?: number | null } | null } | null> | null };

export type GetEditsQueryQueryVariables = Exact<{
  hadithId?: InputMaybe<Scalars['Int']>;
}>;


export type GetEditsQueryQuery = { __typename?: 'Query', edits?: Array<{ __typename?: 'EditLog', id?: number | null, before?: string | null, after?: string | null, diff?: string | null, creator?: string | null, created_at?: string | null } | null> | null };

export type SetSolveReportMutationVariables = Exact<{
  reportId?: InputMaybe<Scalars['String']>;
}>;


export type SetSolveReportMutation = { __typename?: 'Mutation', solveReport?: string | null };

export type GetBooksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBooksQuery = { __typename?: 'Query', allBooks?: Array<{ __typename?: 'Book', id?: number | null, name?: string | null, volumes?: Array<number | null> | null, enabled?: boolean | null, version?: number | null, authorName?: string | null, altTitle?: string | null, translator?: string | null, englishName?: string | null } | null> | null };

export type GetDuasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuasQuery = { __typename?: 'Query', allDuas?: Array<{ __typename?: 'Dua', id?: number | null, name?: string | null, languages?: Array<string | null> | null, path?: string | null, verseGroups?: Array<{ __typename?: 'VerseGroup', name?: string | null, language?: string | null, verses?: Array<{ __typename?: 'Verse', id?: number | null, index?: number | null, content?: string | null } | null> | null } | null> | null } | null> | null };

export type GetArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArticlesQuery = { __typename?: 'Query', allArticles?: Array<{ __typename?: 'Article', id?: number | null, title?: string | null, summary?: string | null, url?: string | null, thumbnail_url?: string | null, created_at?: string | null } | null> | null };

export type ReportsWithPageQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  solved?: InputMaybe<Scalars['Boolean']>;
}>;


export type ReportsWithPageQuery = { __typename?: 'Query', unsolvedReportsCount?: number | null, reports?: Array<{ __typename?: 'Report', id?: number | null, solved?: boolean | null, description?: string | null, identifier?: string | null, created_at?: string | null } | null> | null };

export type ComputeMutationVariables = Exact<{
  text: Scalars['String'];
}>;


export type ComputeMutation = { __typename?: 'Mutation', computeEmbedding?: Array<number | null> | null };


export const GetHadithDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHadith"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hadithNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHadithByNumberAndSection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookSectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapterNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"hadithNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hadithNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"gradingWithReferences"}},{"kind":"Field","name":{"kind":"Name","value":"jsonChains"}},{"kind":"Field","name":{"kind":"Name","value":"startingIndex"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetHadithQuery, GetHadithQueryVariables>;
export const GetReportQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hadithId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportsForHadith"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hadithId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hadithId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"solved"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"solved_by"}}]}}]}}]} as unknown as DocumentNode<GetReportQueryQuery, GetReportQueryQueryVariables>;
export const GetNarratorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNarrator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"narrator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<GetNarratorQuery, GetNarratorQueryVariables>;
export const GetSolvedReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSolvedReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solved"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"solved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solved"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"solved"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetSolvedReportsQuery, GetSolvedReportsQueryVariables>;
export const GetRandomHadithDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRandomHadith"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"randomHadith"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookSection"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetRandomHadithQuery, GetRandomHadithQueryVariables>;
export const ReportHadithDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reportHadith"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ReportHadithMutation, ReportHadithMutationVariables>;
export const GetBookIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBookIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBookIds"}}]}}]} as unknown as DocumentNode<GetBookIdsQuery, GetBookIdsQueryVariables>;
export const GetBookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"book"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"englishName"}},{"kind":"Field","name":{"kind":"Name","value":"volumes"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfDeath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"bookSection"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translator"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"bookSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sectionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"bookSection"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBookQuery, GetBookQueryVariables>;
export const GetBooksAllChaptersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBooksAllChapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"bookNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookSection"}}]}}]}}]}}]} as unknown as DocumentNode<GetBooksAllChaptersQuery, GetBooksAllChaptersQueryVariables>;
export const GetHadithsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHadiths"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHadithByNumberAndSection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookSectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapterNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"gradingWithReferences"}},{"kind":"Field","name":{"kind":"Name","value":"jsonChains"}},{"kind":"Field","name":{"kind":"Name","value":"startingIndex"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetHadithsQuery, GetHadithsQueryVariables>;
export const GetChapterDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChapterDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChapterNameAndBookName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookSectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapterNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookName"}},{"kind":"Field","name":{"kind":"Name","value":"bookType"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"chapterName"}}]}}]}}]} as unknown as DocumentNode<GetChapterDetailsQuery, GetChapterDetailsQueryVariables>;
export const UpdateHadithMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHadithMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hadithId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startingIndex"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHadith"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hadithId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hadithId"}}},{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"Argument","name":{"kind":"Name","value":"startingIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startingIndex"}}}]}]}}]} as unknown as DocumentNode<UpdateHadithMutationMutation, UpdateHadithMutationMutationVariables>;
export const GetDuaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDua"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duaByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"verseGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"verses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDuaQuery, GetDuaQueryVariables>;
export const GetAllDuasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllDuas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDuas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]} as unknown as DocumentNode<GetAllDuasQuery, GetAllDuasQueryVariables>;
export const GetHadithForHadithPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHadithForHadithPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hadithNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHadithByNumberAndSection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookSectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookSectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapterNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapterNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"hadithNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hadithNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"gradingWithReferences"}},{"kind":"Field","name":{"kind":"Name","value":"jsonChains"}},{"kind":"Field","name":{"kind":"Name","value":"startingIndex"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"book"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextHadith"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousHadith"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]} as unknown as DocumentNode<GetHadithForHadithPageQuery, GetHadithForHadithPageQueryVariables>;
export const GetEditsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEditsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hadithId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hadithId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hadithId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"before"}},{"kind":"Field","name":{"kind":"Name","value":"after"}},{"kind":"Field","name":{"kind":"Name","value":"diff"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetEditsQueryQuery, GetEditsQueryQueryVariables>;
export const SetSolveReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setSolveReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solveReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}]}}]} as unknown as DocumentNode<SetSolveReportMutation, SetSolveReportMutationVariables>;
export const GetBooksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"volumes"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"altTitle"}},{"kind":"Field","name":{"kind":"Name","value":"translator"}},{"kind":"Field","name":{"kind":"Name","value":"englishName"}}]}}]}}]} as unknown as DocumentNode<GetBooksQuery, GetBooksQueryVariables>;
export const GetDuasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDuas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDuas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"verseGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"verses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDuasQuery, GetDuasQueryVariables>;
export const GetArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetArticlesQuery, GetArticlesQueryVariables>;
export const ReportsWithPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reportsWithPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"solved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solved"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"solved"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsolvedReportsCount"}}]}}]} as unknown as DocumentNode<ReportsWithPageQuery, ReportsWithPageQueryVariables>;
export const ComputeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"compute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"computeEmbedding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}]}}]} as unknown as DocumentNode<ComputeMutation, ComputeMutationVariables>;